import { EnumsInterface } from "@/interfaces/EnumsInterface";

const Legends:EnumsInterface[] = [
    {id: 1, value: 'Past Due', label: "Past Due"},
    {id: 2, value: 'Scheduled', label: "Scheduled"},
    {id: 3, value: 'Done', label: "Done"},
]

export default Legends 